import React from "react";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import { useTranslation } from "../../../i18n";
import { formatBenefitsPeriodEnd } from "../subscriptionApi";

const ProfessionalBenefitsBanner = ({
  freeRemaining,
  freeAllowance,
  freeUsed,
  periodEnd,
  compact = false,
  className = "",
}) => {
  const { t, locale } = useTranslation();
  const periodLabel = formatBenefitsPeriodEnd(periodEnd, locale);

  if (compact) {
    return (
      <div
        className={`rounded-xl border border-emerald-200/80 bg-emerald-50 px-4 py-3 ${className}`}
      >
        <div className="flex items-start gap-3">
          <MaterialIcon name="verified" className="mt-0.5 shrink-0 text-[20px] text-emerald-700" filled />
          <div className="min-w-0">
            <p className="text-[13px] font-semibold text-emerald-900">
              {t("subscription.freeRemainingBanner", {
                remaining: freeRemaining,
                allowance: freeAllowance,
              })}
            </p>
            {periodLabel ? (
              <p className="mt-1 text-[12px] text-emerald-800/80">
                {t("subscription.resetsOn", { date: periodLabel })}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-5 shadow-sm ${className}`}
    >
      <div className="flex items-start gap-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
          <MaterialIcon name="loyalty" className="text-[22px]" filled />
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-headline-md text-headline-md text-emerald-950">
            {t("subscription.professionalBenefitsTitle")}
          </p>
          <p className="mt-1 text-body-md text-emerald-900/90">
            {t("subscription.freeRemainingBanner", {
              remaining: freeRemaining,
              allowance: freeAllowance,
            })}
          </p>
          {freeUsed > 0 ? (
            <p className="mt-1 text-label-sm text-emerald-800/80">
              {t("subscription.freeUsedThisPeriod", { count: freeUsed })}
            </p>
          ) : null}
          {periodLabel ? (
            <p className="mt-2 text-label-sm text-emerald-800/70">
              {t("subscription.periodEnds", { date: periodLabel })}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProfessionalBenefitsBanner;
